import { useFormikContext } from "formik"
import { useDEFormContext } from "../context/DEFormContext"


const StatusSection = () => {
    const formik = useFormikContext()
    const { appealOutcomeRevisionOptions, punishmentThirdOption, defaultPunishment } = useDEFormContext()

    return (
        <>
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">Outcome of Revision Petition</label>
                <div className="col-sm-8">
                    <select
                        className="form-control"
                        name="deRevisionAppealOutcome"
                        value={formik.values.deRevisionAppealOutcome}
                        onChange={formik.handleChange}
                    >
                        <option value="">Select</option>
                        {appealOutcomeRevisionOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    {formik.touched.deRevisionAppealOutcome &&
                        formik.errors.deRevisionAppealOutcome && (
                            <div className="invalid-feedback d-block">
                                {formik.errors.deRevisionAppealOutcome}
                            </div>
                        )}
                </div>
            </div>
            {

                ['partially', 'punishmentEnhanced'].includes(formik.values.deRevisionAppealOutcome)
                && (
                    <>
                        <div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label">Punishment</label>
                            <div className="col-sm-8">
                                <select
                                    className="form-control"
                                    name="dePunishmentThird"
                                    value={formik.values.dePunishmentThird}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">Select Punishment </option>
                                    {punishmentThirdOption?.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.name}
                                        </option>
                                    ))}
                                </select>
                                {formik.touched.dePunishmentThird &&
                                    formik.errors.dePunishmentThird && (
                                        <div className="invalid-feedback d-block">
                                            {formik.errors.dePunishmentThird}
                                        </div>
                                    )}
                            </div>
                        </div>
                         <div className="form-group row mb-3">
                          <label className="col-sm-4 col-form-label">Date Of Decision Of Revision Petition</label>
                          <div className="col-sm-8">
                           <input
                        type="date"
                        className="form-control"
                        name="deDateDecisionRevisionPetition"
                        value={formik.values.deDateDecisionRevisionPetition}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    />
                            {formik.touched.deDateDecisionRevisionPetition &&
                              formik.errors.deDateDecisionRevisionPetition && (
                                <div className="invalid-feedback d-block">
                                  {formik.errors.deDateDecisionRevisionPetition}
                                </div>
                              )}
                          </div>
                        </div>

                        {Object.values(defaultPunishment).includes(
                            formik.values.dePunishmentThird
                        ) && (
                                <>
                                    <div className="form-group row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                            No. of increment stopped
                                        </label>
                                        <div className="col-sm-8">
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="annualStoppageThird"
                                                value={formik.values.annualStoppageThird}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {formik.touched.annualStoppageThird &&
                                                formik.errors.annualStoppageThird && (
                                                    <div className="invalid-feedback d-block">
                                                        {formik.errors.annualStoppageThird}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </>
                            )}
                    </>
                )}
            <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                    Whether any petition has been filed in court
                </label>
                <div className="col-sm-8">
                    <select
                        className="form-control"
                        name="deAnyPetiton"
                        value={formik.values.deAnyPetiton}
                        onChange={formik.handleChange}
                    >
                        <option value="">Select</option>
                        <option key="yes" value="yes">YES </option>
                        <option key="no" value="no">NO </option>
                    </select>
                    {formik.touched.deAnyPetiton && formik.errors.deAnyPetiton && (
                        <div className="invalid-feedback d-block">
                            {formik.errors.deAnyPetiton}
                        </div>
                    )}
                </div>
            </div>

            {formik.values.deAnyPetiton == 'yes' &&
                <>
                    <div className="form-group row mb-3">
                        <label className="col-sm-4 col-form-label">
                            Court Case Details
                        </label>
                        <div className="col-sm-8">
                            <textarea
                                className="form-control"
                                name="deCourtCase"
                                value={formik.values.deCourtCase}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.deCourtCase && formik.errors.deCourtCase && (
                                <div className="invalid-feedback d-block">
                                    {formik.errors.deCourtCase}
                                </div>
                            )}
                        </div>
                    </div>
                </>
            }


        </>
    )
}

export default StatusSection